/**
 * Reduces a full address label ("Gentse Steenweg 243c, 9160 Lokeren, België")
 * to its city ("Lokeren"). Partner offerings are rendered anonymously, so the
 * street — which identifies the partner — must never reach the UI.
 *
 * Best effort: takes the segment after the first comma and strips a leading
 * postal code. A label without commas is assumed to already be a city.
 */
export function addressCityLabel(name: string | null | undefined): string | null {
    if (!name) return null;
    const segments = name.split(',').map(segment => segment.trim());
    // No comma: can't isolate a city. Reject anything with a digit (house number
    // → street) so partner-identifying street data never reaches the UI; a
    // digit-free token is assumed to already be a bare city name.
    if (segments.length < 2) return /\d/.test(name) ? null : name;
    // Strip a leading BE ("9160") or NL ("1234 AB") postal code.
    const secondSegment = segments[1];
    if (!secondSegment) return null;
    return secondSegment.replace(/^\d{4}\s*(?:[A-Z]{2}\s+)?/, '').trim() || secondSegment;
}
